// const serverURL = "http://localhost:3000/";
const serverURL = process.env.VUE_APP_API_URL + "/";
export default serverURL;
